import { render, staticRenderFns } from "./unimed.vue?vue&type=template&id=f61053fc&scoped=true"
import script from "./unimed.vue?vue&type=script&lang=js"
export * from "./unimed.vue?vue&type=script&lang=js"
import style0 from "./unimed.vue?vue&type=style&index=0&id=f61053fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61053fc",
  null
  
)

export default component.exports